import React, { useState, useEffect } from 'react';
import {
  Divider,
  Card,
  CardHeader,
  Container,
  Grid,
  Tab,
  Box,
} from '@mui/material';
import axios from 'axios';
import { url } from 'src/Helpers/utils/Constant';

import { IOtherBusinessLicense } from 'src/Types/module/UpdateRequest/RequestOtherBusinessLicense';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import OtherBusinessIndex from './OtherBusinessIndex';

const RequestOtherBusinessLicenseInfo = () => {
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [otherBusinessLicenseInfo, setOtherBusinessLicenseInfo] = useState<
    IOtherBusinessLicense[]
  >([]);
  const [value, setValue] = React.useState('pending');

  useEffect(() => {
    setIsLoading(true);
    try {
      (async function () {
        const { data } = await axios.get(
          `${url}/api/atab/member-company/update-request/member/association?status=${value}`
        );

        if (data.success) {
          setOtherBusinessLicenseInfo(data.data);
          setIsLoading(false);
        } else {
          setIsLoading(false);
        }
      })();
    } catch (error) {
      setIsLoading(false);
    }
  }, [value]);

  return (
    <Container sx={{ mt: 4 }} maxWidth='xl'>
      <Grid
        container
        direction='row'
        justifyContent='center'
        alignItems='stretch'
        spacing={3}
      >
        <Grid item xs={12}>
          <TabContext value={value}>
            <Card>
              <CardHeader
                title='Other Business License information'
                action={
                  <Box sx={{ width: '100%' }}>
                    <Box sx={{ borderColor: 'divider' }}>
                      <TabList
                        onChange={(_event, newValue) => setValue(newValue)}
                        aria-label='lab API tabs example'
                      >
                        <Tab label='Pending' value='pending' />
                        <Tab label='Approved' value='approved' />
                        <Tab label='Rejected' value='rejected' />
                      </TabList>
                    </Box>
                  </Box>
                }
              />
              <Divider />
              <TabPanel value='pending'>
                <OtherBusinessIndex
                  isLoading={isLoading}
                  otherBusinessLicenseInfo={otherBusinessLicenseInfo}
                />
              </TabPanel>
              <TabPanel value='approved'>
                <OtherBusinessIndex
                  isLoading={isLoading}
                  otherBusinessLicenseInfo={otherBusinessLicenseInfo}
                />
              </TabPanel>
              <TabPanel value='rejected'>
                <OtherBusinessIndex
                  isLoading={isLoading}
                  otherBusinessLicenseInfo={otherBusinessLicenseInfo}
                />
              </TabPanel>
              {/* <Box p={2}>
              <TablePagination
                component='div'
                count={companyInfo?.length}
                onPageChange={handlePageChange}
                onRowsPerPageChange={handleLimitChange}
                page={page && page}
                rowsPerPage={limit}
                rowsPerPageOptions={[25, 50, 75, 100]}
              />
            </Box> */}
            </Card>
          </TabContext>
        </Grid>
      </Grid>
    </Container>
  );
};

export default RequestOtherBusinessLicenseInfo;
